import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { doGetAllUsers, doCreateUser, doUpdateUser, doDeleteUser } from "./thunk";

const usersAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const userSlice = createSlice({
  name: "user",
  initialState: {
    isFetching: false,
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllUsers.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetAllUsers.fulfilled, (state, action) => {
      const { users, meta } = action.payload;
      state.isFetching = false;
      state.metadata = meta;
      usersAdapter.setAll(state, users);
    });
    builder.addCase(doGetAllUsers.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doCreateUser.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doCreateUser.fulfilled, (state, action) => {
      state.isFetching = false;
      usersAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreateUser.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdateUser.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doUpdateUser.fulfilled, (state, action) => {
      state.isFetching = false;
      usersAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateUser.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doDeleteUser.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doDeleteUser.fulfilled, (state, action) => {
      state.isFetching = false;
      usersAdapter.removeOne(state, action.meta.arg);
    });
    builder.addCase(doDeleteUser.rejected, state => {
      state.isFetching = false;
    });
  },
});

export const {
  selectAll: selectAllUsers,
  selectById: selectUserById,
  selectIds: selectUserIds,
} = usersAdapter.getSelectors(state => state.user);

const { reducer: userReducer } = userSlice;
export default userReducer;
